const clientExecutionEventType = 'CLIENT_EXECUTION';
const clientExecutionResultEventType = 'CLIENT_EXECUTION_RESULT';

type ClientActionExecutionResult =
  | {
      success: true;
      data: Record<string, any>;
    }
  | {
      reason: string;
      success: false;
    };

export const executeClientAction = (key: string, inputs: Record<string, any>) => {
  return new Promise<ClientActionExecutionResult>((resolve) => {
    // When the iFrame sends multiple messages to the parent window,
    // we use this to track which response belongs to which request.
    const messageId = crypto.randomUUID();

    const handleResponse = (
      event: MessageEvent<{
        type: string;
        messageId: string;
        result: ClientActionExecutionResult;
      }>,
    ) => {
      if (event.data.messageId === messageId && event.data.type === clientExecutionResultEventType) {
        window.removeEventListener('message', handleResponse);
        resolve(event.data.result);
      }
    };

    // Current window of execution
    window.addEventListener('message', handleResponse);

    // Send message to parent window
    window.parent.postMessage(
      {
        type: clientExecutionEventType,
        messageId,
        actionKey: key,
        inputs,
      },
      '*',
    );

    // Timeout after 5 seconds
    setTimeout(() => {
      window.removeEventListener('message', handleResponse);

      resolve({
        success: false,
        reason: `Client Action handler with key ${key} timed out`,
      });
    }, 5000);
  });
};
